import { Rule } from './lexer'

export const blockRules: Rule[] = [
  new Rule('title', /^\# (?<v>.+)/),
  new Rule('subtitle', /^\#{2} (?<v>.+)/),
  new Rule('space', /^\n\n/),
  new Rule('code-block', /^\`{3}(?<v>[\s\S]+)\`{3}/),
  new Rule('math-block', /^\${2}(?<v>[\s\S]+)\${2}/),
  new Rule('table', /^(?<v>(<=(\r?\n){2}|^)([^\r\n]*\|[^\r\n]*(\r?\n)?)+(?=(\r?\n){2}|))/gm),
  new Rule('task-item', /^(?<d>[ ]*)[\*\-]\s?(?<c>\[[ x]\])\s(?<v>.+)/),
  new Rule('list-item', /^(?<d>[ ]*)[\*\-]\s(?<v>.+)/),
  new Rule('quote', /^(?<d>[ ]*)(\>)[ ]*(?<v>.+)/),
  new Rule('divider', /^(?<v>[-*_]{3,})/),
  new Rule('image', /^\!\[(?<v>.+)\]\((?<href>.+)\)/)
]

export const inlineRules: Rule[] = [
  new Rule('math', /^\$(?<v>.+)\$/),
  new Rule('code', /^\`(?<v>.+)\`/),
  new Rule('bold', /^\*{2}(?<v>.+)\*{2}/),
  new Rule('italic', /^\*(?<v>.+)\*/),
  new Rule('underline', /^\_{2}(?<v>.+)\_{2}/),
  new Rule('special', /^\[(?<v>.+)\]\((?<href>.+)\)/)
]
